import React from "react";
import ServiceHero from "../../components/ServiceHero";
import LogoDesignPre from "./LogoDesignPre";
import Services from "./Services";
import Client from "../client/Client";
import FAQ from "../../components/FAQ";
import Footer from "../Footer/Footer";
import FormHeroSection from "../../components/FormHeroSection";

const LogoDesign = () => {
  return (
    <>
      <ServiceHero
        eyebrow="Logo Design"
        title="A logo people"
        highlight="remember."
        description="We translate what makes your business distinct into a clear, confident identity that feels recognizably yours wherever your brand appears."
        features={[
          "Strategy before aesthetics",
          "Distinctive concept development",
          "Files ready for every format",
        ]}
        image="/Images/logoDesignHome.webp"
        imageAlt="Illustration representing a distinctive brand identity"
        visualLabel="Identity with meaning"
        visualTitle="A memorable mark built from what makes your brand different."
      />
      <Services />
      <FormHeroSection/>
      <LogoDesignPre />
      <Client />
     
      <FAQ
        title="How can I design a logo on Abscod"
        title1="What is the logo design process?"
        title2="How long does it take to design a logo?"
        title3="What file formats will I receive?"
        title4="Can I use my logo on social media and my website?"
        paragraph="A logo is an essential part of your brand's identity and serves as a visual representation of your business. A well-designed logo can help you stand out in a crowded market, build brand recognition, and establish trust with your target audience."
        paragraph1="Our designers work closely with you to understand your brand's personality, values, and target audience, and then create a range of concepts for you to choose from. Once you've chosen a concept, we refine it until it's perfect."
        paragraph2="The time it takes to design a logo can vary depending on several factors, such as the complexity of the design, the number of revisions required, and the responsiveness of the client. Typically, the logo design process takes between 2-4 weeks from start to finish."
        paragraph3="Once your logo is finalized, we provide you with a range of file formats, including JPEG, PNG, PDF, and vector files. These files are optimized for various uses, such as web, print, and signage."
        paragraph4="Yes, you can use your logo on social media, your website, and other marketing materials. In fact, we recommend using your logo consistently across all platforms to build brand recognition and establish a strong visual identity for your business."
      />
      <Footer />
    </>
  );
};

export default LogoDesign;

// {Custom logo design: Offer clients a custom logo design service where they can work with your design team to create a unique logo that reflects their brand's personality and values.

// Logo design packages: Offer different logo design packages at different price points with varying levels of service. This could include options such as the number of logo design concepts, revisions, and file formats.

// Logo design questionnaire: Provide clients with a logo design questionnaire that helps them to articulate their brand's values, target audience, and overall aesthetic preferences. This will help your design team to create a logo that accurately represents their brand.

// Design collaboration: Allow clients to collaborate with your design team throughout the logo design process to provide feedback, make changes, and ensure that the final design meets their expectations.

// Quick turnaround: Provide clients with a quick turnaround time for logo design services. This could include a guaranteed timeline for initial logo concepts, revisions, and final delivery of files.

// Logo file formats: Provide clients with logo files in a variety of formats, such as vector files (AI, EPS, SVG), raster files (PNG, JPG), and other formats that are commonly used for branding purposes.

// Customer support: Offer clients excellent customer support throughout the entire logo design process, including initial consultations, revisions, and final delivery of files. This will help to ensure that clients have a positive experience and are satisfied with the final product.}
